import type { SupportedLocale } from '@/lib/utils/localization/getFlattenedLocales'
import type { SendRequestType } from '@/lib/utils/shared/httpTools'
import httpTools from '@/lib/utils/shared/httpTools'
import type { CustomerType } from '@/store/types/user'
import type { Alpha2CountryCode } from '@/lib/types/alpha2CountryCode'
import type { HydraErrorType } from '../_hydraError.d'

type PaymentField = {
  name: string
  required: boolean
  conditions?: {
    entity: string
    property: string
    values: string[]
    condition: string
  }[]
}

type PaymentMethodDetails = {
  bankName: string
  fields: PaymentField[]
}

type PaymentTransaction = {
  description: string
  type: string
  method: string
  methodDetails: PaymentMethodDetails
  fields: PaymentField[]
}

type PaymentOption = {
  transactions: {
    items: PaymentTransaction[]
  }
}

export type HydraGetCashPaymentOptionsResponse = {
  items: PaymentOption[]
}

type HydraGetCashPaymentOptionsProps = {
  customerType: CustomerType
  alpha2: Alpha2CountryCode
  shipMethod: string
  token: string
  locale: SupportedLocale
}

export const buildHeaders = ({ locale }: { locale: SupportedLocale }) => ({
  'Accept-Language': locale,
})

export const HydraGetCashPaymentOptions = async ({
  customerType,
  alpha2,
  shipMethod,
  token,
  locale,
}: HydraGetCashPaymentOptionsProps) => {
  const headers = buildHeaders({ locale })
  const withAuth = !!token

  const request: SendRequestType = {
    method: 'POST',
    withAuth,
    token,
    headers,
    data: {
      order: {
        customer: {
          href: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/customers?type=${customerType}`,
        },
        shipToAddress: {
          country: alpha2,
        },
        shippingMethod: {
          href: `${process.env.NEXT_PUBLIC_HYDRA_BASE_URL}/shippingmethods?${shipMethod}`,
        },
      },
      vary: {
        transactions: [],
      },
    },
    url: `/quotes`,
  }

  return httpTools.sendRequest<
    HydraGetCashPaymentOptionsResponse & HydraErrorType
  >(request)
}
